import { MsalProvider } from '@azure/msal-react';
import { datadogRum } from '@datadog/browser-rum';
import formbricks from '@formbricks/js';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { msalClient } from './auth';
import AppContext from './contexts/AppContext';
import reportWebVitals from './reportWebVitals';

import './index.css';

const env = process.env.REACT_APP_ENV;

const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

if (env === 'prod' && userTimeZone.includes('America')) {
	datadogRum.init({
		applicationId: '021f755d-e4f6-444e-9664-a2e7f0c339fd',
		clientToken: 'pubb7ce1cfb505dc459a33fccdd47fbeb14',
		// `site` refers to the Datadog site parameter of your organization
		// see https://docs.datadoghq.com/getting_started/site/
		site: 'datadoghq.eu',
		service: 'fxt.ops.services.dispatch-fe',
		env: 'dispatch-prod',
		// Specify a version number to identify the deployed version of your application in Datadog
		version: '1.0.0',
		trackUserInteractions: true,
		sessionSampleRate: 100,
		sessionReplaySampleRate: 20,
		defaultPrivacyLevel: 'mask-user-input',
	});
}

if (typeof window !== 'undefined') {
	formbricks.setup({
		environmentId: 'cmanso10m079mm3016y5zvdma',
		appUrl: 'https://surveys.cro.flix.tech',
	});
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<MsalProvider instance={msalClient}>
		<React.StrictMode>
			<AppContext />
		</React.StrictMode>
	</MsalProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
